<template>
  <div class="modal-goodsEdit">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑App商品</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body" v-loading="loadingModal">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="24" class="item">
              <el-steps :active="activeStep"  align-center>
                <el-step title="基本信息"></el-step>
                <el-step title="商品图片"></el-step>
                <el-step title="商品详情"></el-step>
                <el-step title="商品价格"></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <div style="height: 10px"></div>
          <el-row>
            <el-col :span="24" class="item">
              <el-tabs v-model="tab" tab-position="left" style="height: 400px;">
                <el-tab-pane label="基本信息">


                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品名称" required prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品副标题">
                        <el-input v-model="editForm.nameMore" placeholder="请输入商品副标题"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品政府分类" required prop="goodsClassGovernmentCode">
                        <el-cascader
                            v-model="editForm.goodsClassGovernmentCode"
                            :options="goodsClassGovValue"
                            :props="options" style="width:100%" @change="goodsClassGovChange"></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="商家商品分类">

                        <!--                                <el-cascader-->
                        <!--                                    v-model="editForm.goodsClassBusinessCode"-->
                        <!--                                    :options="goodsClassBusinessValue"-->
                        <!--                                    :props="options1" style="width:100%"></el-cascader>-->

                        <el-select v-model="editForm.goodsClassBusinessCode" style="width:100%">
                          <el-option
                              v-for="item in goodsClassBusinessValue"
                              :key="item.goodsClassBusinessCode"
                              :label="item.name"
                              :value="item.goodsClassBusinessCode">
                          </el-option>
                        </el-select>

                      </el-form-item>

                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="商品类型" required prop="goodsType">
                        <el-select v-model="editForm.goodsType" style="width:100%">
                          <el-option
                              v-for="item in goodsTypeValue"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" class="item">
                      <el-form-item label="是否推荐" required prop="isRecommend">
                        <el-radio-group v-model="editForm.isRecommend" style="width:100%">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="是否特价" required prop="isBargainPrice">
                        <el-radio-group v-model="editForm.isBargainPrice" style="width:100%">
                          <el-radio :label="1">是</el-radio>
                          <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>

                    <el-col :span="12" class="item">
                      <el-form-item label="是否下架" required>
                        <el-radio-group v-model="editForm.status" style="width:100%">
                          <el-radio :label="2">是</el-radio>
                          <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

<!--                  <el-row>-->
<!--                    <el-col :span="12" class="item">-->
<!--                      <el-form-item label="是否APP显示">-->
<!--                        <el-radio-group v-model="editForm.isAPP" style="width:100%">-->
<!--                          <el-radio :label="1">是</el-radio>-->
<!--                          <el-radio :label="0">否</el-radio>-->
<!--                        </el-radio-group>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12" class="item">-->
<!--                      <el-form-item label="是否收银机显示">-->
<!--                        <el-radio-group v-model="editForm.isPad" style="width:100%">-->
<!--                          <el-radio :label="1">是</el-radio>-->
<!--                          <el-radio :label="0">否</el-radio>-->
<!--                        </el-radio-group>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
<!--                  </el-row>-->

                </el-tab-pane>

                <el-tab-pane label="商品图片">
                  <el-row>
                    <el-col :span="24" class="item">
                      <el-form-item label="商品轮播图" class="imgLabel" required>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload
                              class="avatar-uploader"
                              action="ddd"
                              list-type="picture-card"
                              :before-upload="beforeUpload1"
                          >
                            <img v-if="editForm.head1" :src="editForm.head1" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload
                              class="avatar-uploader"
                              action="ddd"
                              list-type="picture-card"
                              :before-upload="beforeUpload2"
                          >
                            <img v-if="editForm.head2" :src="editForm.head2" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload
                              class="avatar-uploader"
                              action="ddd"
                              list-type="picture-card"
                              :before-upload="beforeUpload3"
                          >
                            <img v-if="editForm.head3" :src="editForm.head3" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload
                              class="avatar-uploader"
                              action="ddd"
                              list-type="picture-card"
                              :before-upload="beforeUpload4"
                          >
                            <img v-if="editForm.head4" :src="editForm.head4" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <el-upload
                              class="avatar-uploader"
                              action="ddd"
                              list-type="picture-card"
                              :before-upload="beforeUpload5"
                          >
                            <img v-if="editForm.head5" :src="editForm.head5" style="width: 78px;height: 78px;display: block;">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </div>
                        <div style="float: left;margin-right: 10px;">
                          <div style="border: 1px solid #eee;border-radius: 5px;">
                            <i class="el-icon-close avatar-uploader-icon" @click="removeHead()"></i>
                          </div>
                        </div>
                        <div style="clear: both;"></div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="商品详情">
                  <el-row>
                    <el-col :span="24" class="item">
                      <el-form-item label="商品详情" required>
                        <Quill placeholder='请输入详情' v-model='editForm.details' editorRef='editQuill' @input="handelIncrease"></Quill>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="商品价格">
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品价格（元）" required>
                      <el-input v-model.trim="editForm.price" min="0" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输商品价格"
                                type="number">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品库存" required>
                      <div style="margin-top:40px">
                        <el-input-number :precision='0' :min="0" v-model.trim="editForm.stock" ></el-input-number>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="item"  v-if='atrList.length==0'>
                    <el-form-item label="商品最小价格（元）" required>
                      <el-input v-model.trim="editForm.priceMin" min="0" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''" placeholder="请输最低商品价格"
                                type="number">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <div v-if='atrList.length>0'>
                    <el-col :span="24" class="item" v-for="(item,i) in atrList" :key='i'>
                      <el-form-item :label="item.name"  required>
                        <el-checkbox-group v-model="editForm.selectAtrValue[item.key]" @change="selectChangeAtr" style="margin-top: 40px;">
                          <el-checkbox v-for="items in item.attrValue" :label="items.attrValueCode" :key="items.attrValueCode">{{items.name}}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                    <template>
                      <el-table
                          :data="tablePriceArray"
                          :span-method="arraySpanMethod"
                          border
                          v-if="tablePriceArray.length>0"
                          style="width: 100%">
                        <el-table-column
                            v-for="(item,i) in atrList"
                            :key='i'
                            :prop="item.key.replace('Code','Name')"
                            :label="item.name">
                        </el-table-column>
                        <el-table-column
                            prop="price"
                            label="价格">
                          <template slot-scope="item">
                            <el-input size="small" v-model.trim="item.row.price" min="0" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"  placeholder="请输商品价格"
                                      type="number">
                              <template slot="append">
                                <span>元</span>
                              </template>
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="price"
                            label="价格">
                          <template slot-scope="item">
                            <el-input size="small" v-model.trim="item.row.priceMin" min="0" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"  placeholder="请输商品价格"
                                      type="number">
                              <template slot="append">
                                <span>元</span>
                              </template>
                            </el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="price"
                            label="库存">
                          <template slot-scope="item">
                            <!-- <el-input size="small" v-model.trim="item.row.stock" placeholder="请输商品价格"
                                    type="number">
                            </el-input> -->
                            <el-input-number size="small" :precision='0' :min="0" v-model.trim="item.row.stock"></el-input-number>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </div>
                </el-tab-pane>

              </el-tabs>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <!-- <el-button v-show="activeStep<3" :loading="loading" type="primary" @click="nextOpen">下一步</el-button> -->
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import Quill from "@/components/Quill";

export default {
  name: 'Edit',
  props:['goodsClassGovValue','goodsClassBusinessValue'],
  data() {
    return {
      loading: false,
      disPrice: true,
      disImg: true,
      loadingModal: true,
      disDetails: true,
      activeStep:0,
      tablePriceArray:[],
      atrList:[],
      disabledTab:[false,true,true,true],
      tab:'0',
      imageUrl:"",
      column:'',
      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },
      options1:{
        value:'goodsClassBusinessCode',
        label:'name',
        children:'secondGoodsClassBusinessList',
        emitPath:false
      },
      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
        nameMore:'',
        goodsType:"",
        priceList:[],
        selectAtrValue:{},
        goodsClassGovernmentCode:'',
        goodsClassBusinessCode:'',
        stock:'',
        head1:'',
        head2:'',
        head3:'',
        head4:'',
        head5:'',
        details:'',
        isDelete:'',
        price:'',
        priceMin:'',
        isRecommend:'',
        goodsClassCode:'',
        isBargainPrice:'',
        priceSection:'',
        goodsCode:"",
        isAPP:'',
        isPad:'',
        status:'',
      },
      rules:{
        name:[
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        nameMore:[
          { required: true, message: '请输入商品副标题', trigger: 'blur' }
        ],
        goodsType:[
          { required: true, message: '请选择商品类型', trigger: 'blur' }
        ],
        isBargainPrice:[
          { required: true, message: '请选择是否特价', trigger: 'blur' }
        ],
        isRecommend:[
          { required: true, message: '请选择是否推荐', trigger: 'blur' }
        ],
        goodsClassGovernmentCode:[
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        price:[
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock:[
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        head1:[
          { required: true, message: '请至少上传一张图片', trigger: 'blur' }
        ],
        details:[
          { required: true, message: '请编辑详情', trigger: 'blur' }
        ],
      },
      status: [{
        value: 0,
        label: '否'
      }, {
        value: 1,
        label: '是'
      }],
      goodsTypeValue: [ {
        value: 2,
        label: '服务类不可合并'
      }, {
        value: 3,
        label: '服务类可合并'
      }],


    }
  },
  components:{Quill},
  methods: {
    init(row){
      this.loading = false;
      this.tab='0'
      this.activeStep=4
      this.atrList=[]
      this.tablePriceArray=[]
      this.editForm.selectAtrValue={}
      this.editForm.goodsClassCode=row.goodsClassCode;
      this.editForm.goodsClassBusinessCode=row.goodsClassBusinessCode;
      this.editForm.goodsClassGovernmentCode=row.goodsClassGovernmentCode;
      this.getPriceArray(row.goodsClassGovernmentCode,row.goodsPriceDTOList)
      this.editForm.name=row.name;
      this.editForm.priceMin=row.priceMin;
      this.editForm.nameMore=row.nameMore;
      this.editForm.isRecommend=row.isRecommend;
      this.editForm.goodsCode=row.goodsCode;
      this.editForm.goodsType=row.goodsType;
      this.editForm.isBargainPrice=row.isBargainPrice;
      this.editForm.details=row.details;
      this.editForm.isAPP=row.isAPP;
      this.editForm.isPad = row.isPad;
      this.editForm.status = row.status;
      for(var key=0;key<=4;key++){
        if(row['head'+(key+1)]){
          this.editForm['head'+(key+1)]=this.$imgUrl+row['head'+(key+1)];
        }else{
          this.editForm['head'+(key+1)]='';
        }
      }
    },
    getPriceArray(addGoodsClassCode,goodsPriceDTOList){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsAttribute/ListByGoodsClassCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          goodsClassCode:addGoodsClassCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.loadingModal=false
              var data=response.data.data
              if(data.length==0){
                if(goodsPriceDTOList){
                  this.editForm.price=goodsPriceDTOList[0].price
                  this.editForm.stock=goodsPriceDTOList[0].stock
                }else{
                  this.editForm.price='';
                  this.editForm.stock='';
                }
                return;
              }else{
                var list=[]
                for(var i in data){
                  var attrValue=''
                  let datai=data[i]
                  let attributeName=datai.code.replace('G','g')
                  let attributeListName=attributeName.replace('Code','List')
                  attrValue=JSON.stringify(datai[attributeListName])
                  attrValue=attrValue.replace(new RegExp(attributeName,'g'),'attrValueCode')
                  attrValue=attrValue.replace(/"status":1/g,'"status":"'+attributeName+'"')
                  attrValue=JSON.parse(attrValue)
                  this.$set(this.editForm.selectAtrValue,attributeName,[])
                  let listvalue={
                    key:attributeName,
                    name:datai.name,
                    attrValue:attrValue,
                  }

                  list.push(listvalue)
                }
                this.atrList=list
                //回显排序
                if(goodsPriceDTOList){
                  for(var k in goodsPriceDTOList){
                    delete goodsPriceDTOList[k].goodsCode
                    delete goodsPriceDTOList[k].goodsPriceCode
                  }
                  this.tablePriceArray=goodsPriceDTOList
                  var key=Object.keys(this.editForm.selectAtrValue)[0].replace('Code','Name')
                  this.tablePriceArray.sort(this.compare(key))
                }
                //回显选项
                for(var j in this.tablePriceArray){
                  for(var m in this.editForm.selectAtrValue){
                    if(this.tablePriceArray[j][m]){
                      this.editForm.selectAtrValue[m].push(this.tablePriceArray[j][m])
                    }
                  }
                }
              }
            }else if(response.data.error === 1){
              this.$emit("closeAdd");
              this.$message.error(response.data.message)
            }
          }
      )
    },
    keyupEvent(){
      console.log(this.tablePriceArray)
    },
    goodsClassGovChange(val){
      if(this.editForm.goodsClassCode!=val){
        this.tablePriceArray=[]
        this.atrList=[]
        this.editForm.selectAtrValue={}
        this.loadingModal=true
        this.getPriceArray(val)
      }
      this.editForm.goodsClassCode=val
    },
    fromName(list,index,array,template) {
      var lists=list[index].attrValue
      for(var i in lists){
        let templates={}
        var name=lists[i].status.replace('Code','Name')
        templates[lists[i].status]=lists[i].attrValueCode
        templates[name]=lists[i].name
        var template1=Object.assign(templates,template);
        if(index!=0){
          var arrayList=this.fromName(list,index-1,array,template1)
          array.concat(arrayList)
        }else{
          template1.price=0
          template1.stock=0
          array.push(template1)
        }
      }
      return array
    },
    selectChangeAtr(){
      var data=this.editForm.selectAtrValue
      var is=true
      for(var i in data){
        if(data[i].length==0){
          is=false
        }
      }
      if(is){
        const atrList=JSON.parse(JSON.stringify(this.atrList));
        var list=this.getAtrList(data,atrList)
        var table=this.fromName(list,list.length-1,[],{})
        this.tablePriceArray=this.getTablePriceArray(table)
        var key=Object.keys(this.editForm.selectAtrValue)[0].replace('Code','Name')
        this.tablePriceArray.sort(this.compare(key))
      }else{
        this.tablePriceArray=[]
      }
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1.localeCompare(value2);
      }
    },
    getTablePriceArray(table){
      for(var i in table){
        for(var j in this.tablePriceArray){
          if(this.objvequal(table[i],this.tablePriceArray[j])){
            table[i].price=this.tablePriceArray[j].price
            table[i].stock=this.tablePriceArray[j].stock
          }
        }
      }
      return table
    },
    objvequal(obj1,obj2){
      for(var i in obj1){
        if(i!='price'&&i!='stock'){
          if (obj1[i] != obj2[i]) {
            return false;
          }
        }
      }
      return true;
    },
    getAtrList(data,list){
      for(var i in list){
        for (let j = list[i].attrValue.length - 1; j >= 0; j--) {
          var code=list[i].attrValue[j].attrValueCode
          if(data[list[i].key].indexOf(code)==-1){
            list[i].attrValue.splice(j,1);
          }
        }
      }
      return list
    },
    beforeUpload1(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        that.editForm.head1 = that.$imgUrl+res.data.data.path
      })

    },
    handelIncrease(step) {
      this.editForm.detail=step
    },
    beforeUpload2(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.editForm.head2 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload3(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.editForm.head3 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload4(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.editForm.head4 = that.$imgUrl+res.data.data.path
      })

    },
    beforeUpload5(file){
      let fd = new FormData();
      fd.append('file',file);//传文件
      fd.append('staffCode',getStaffCode());//传其他参数
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        console.log(res.data);
        that.editForm.head5 = that.$imgUrl+res.data.data.path
      })

    },
    removeHead() {

      this.$prompt('输入删除第几个主图', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {

        if(value == 1){
          this.editForm.head1 = '';
        }
        if(value == 2){
          this.editForm.head2 = '';
        }
        if(value == 3){
          this.editForm.head3 = '';
        }
        if(value == 4){
          this.editForm.head4 = '';
        }
        if(value == 5){
          this.editForm.head5 = '';
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });


    },
    closeSelf() {
      this.$emit("closeEdit");
      this.loadingModal=true
    },

    confirm(){
      this.$refs.editForm.validate((valid) => {
        if(!valid){
          this.$message.warning('请完善基本信息')
          return
        }
      })
      if(!this.editForm.head1){
        this.$message.warning('请至少选择一张图片')
        return
      }
      if(!this.editForm.details){
        this.$message.warning('请编辑商品详情')
        return
      }
      if(this.atrList.length>0){
        if(this.tablePriceArray.length==0){
          this.$message.warning('请选择完整的商品属性')
          return;
        }
        for(var i in this.tablePriceArray){
          if(this.tablePriceArray[i].price==0){
            this.$message.warning('请完善商品价格')
            return;
          }
        }
      }else{
        if(!this.editForm.price){
          this.$message.warning('请填写商品价格')
          return;
        }
        if(!this.editForm.stock){
          this.$message.warning('请填写商品库存')
          return;
        }
      }
      this.addSubmit();
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      this.columns=column
      var key=Object.keys(this.editForm.selectAtrValue)[0]
      if (columnIndex === 0) {
        if(rowIndex ===0 || row[key] != this.tablePriceArray[rowIndex-1][key]){
          let rowspan = 0;
          this.tablePriceArray.forEach(element => {
            if(element[key] === row[key]){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
    },
    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.editForm.head1=this.editForm.head1.replace(this.$imgUrl,'')
      if(this.editForm.head2){
        this.editForm.head2=this.editForm.head2.replace(this.$imgUrl,'')
      }
      if(this.editForm.head3){
        this.editForm.head3=this.editForm.head3.replace(this.$imgUrl,'')
      }
      if(this.editForm.head4){
        this.editForm.head4=this.editForm.head4.replace(this.$imgUrl,'')
      }
      if(this.editForm.head5){
        this.editForm.head5=this.editForm.head5.replace(this.$imgUrl,'')
      }
      if(!this.editForm.stock){
        this.editForm.stock=0
      }
      if(!this.editForm.priceMin){
        this.editForm.priceMin=0
      }
      this.editForm.priceList=this.tablePriceArray

      if(this.atrList.length==0){
        this.editForm.priceList=[{goodsColorCode:'',goodsSizeCode:'',stock:this.editForm.stock,price:this.editForm.price}]
        this.editForm.priceSection=this.editForm.price
      }else{
        this.tablePriceArray.sort(function(a,b){
          return a.price-b.price
        })
        this.editForm.priceSection=this.tablePriceArray[0].price+'~'+this.tablePriceArray[this.tablePriceArray.length-1].price
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/EditApp",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.loadingModal=true
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}

</script>





<style lang="scss" scoped>

.modal-goodsEdit {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  overflow-y: auto;
  padding: 0px 0px;

  .modal {
    background-color: #fff;
    box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    margin: 50px 0px;

    .imgLabel /deep/ .el-form-item__content{
      margin-top: 40px;
    }
    .modal-body .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width:80px;
      height: 80px;
    }
    .modal-body  .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .modal-body   .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .modal-body .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    /deep/ .el-tabs .el-tabs__content{
      height: 100%;
      overflow: auto;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      overflow-y:auto;
      height:400px;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}

.avatar-uploader /deep/ .el-upload--picture-card{
  width: 80px;
  height: 80px;
  line-height: 90px;
}
.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
